import dayjs from "dayjs";
import { SearchItem } from "interfaces";
import { useTranslation } from "react-i18next";
import { Button, Form, Input } from "semantic-ui-react";
import { DatePicker, Entity, Enum } from "..";
export interface FilterFormProps {
  onClose: Function;
  filter: SearchItem[];
  values: any;
  onChange: (values: any) => void;
  setQuery: (query: any) => void;
}
export default function FilterForm({
  onClose,
  filter,
  onChange,
  values,
  setQuery,
}: FilterFormProps): React.ReactElement {
  const { t } = useTranslation();
  function handleChange(name: string, value: any) {
    console.log("handle change ", { name, value });
    let tmp = { ...(values || {}) };
    tmp[name] = value;
    onChange(tmp);
  }
  function onSubmit() {
    setQuery(values);
    // onClose();
  }
  return (
    <Form
      onSubmit={() => {
        onSubmit();
      }}
    >
      {filter.map((item, index) => {
        switch (item.control) {
          case "single-date":
            return (
              <div className="w-1/2 inline-block p-2">
                <Form.Field key={index}>
                  <label>{t(item.label)} </label>
                  <DatePicker
                    isClearable
                    selected={
                      values[item.field] && values[item.field][0]
                        ? values[item.field][0]
                        : null
                    }
                    onChange={(val: Date) => {
                      if (!val) {
                        return handleChange(item.field, []);
                      }
                      let tmp: any = [];
                      if (values[item.field]) {
                        tmp = [...values[item.field]];
                      }
                      tmp[0] = dayjs(val).startOf("day").toDate();
                      tmp[1] = dayjs(val).endOf("day").toDate();
                      handleChange(item.field, tmp);
                    }}
                    dateFormat="dd/MM/yyyy"
                  />
                </Form.Field>
              </div>
            );
          case "entity":
            return (
              <div className="w-1/2 inline-block p-2">
                <Form.Field key={index}>
                  <label>{t(item.label)} </label>
                  <Entity
                    value={values[item.field]}
                    values={values[item.field]}
                    gridName={item.gridName}
                    multiple={false}
                    onChange={(val: any) => {
                      handleChange(item.field, val);
                    }}
                  />
                </Form.Field>
              </div>
            );
          case "date":
            return (
              <div className="flex w-full" key={index}>
                <div className="w-1/2 p-2">
                  <Form.Field className="w-1/2 inline p-2">
                    <label>{t("From date")}</label>
                    <DatePicker
                      selected={
                        values[item.field] && values[item.field][0]
                          ? values[item.field][0]
                          : new Date()
                      }
                      filterDate={(date) => {
                        let toDate = null;
                        if (values[item.field] && values[item.field][1]) {
                          toDate = values[item.field][1];
                        }
                        if (!toDate) return true;
                        return date < toDate;
                      }}
                      onChange={(val: Date) => {
                        let tmp: any = [];
                        if (values[item.field]) {
                          tmp = [...values[item.field]];
                        }
                        tmp[0] = dayjs(val).startOf("day").toDate();
                        handleChange(item.field, tmp);
                      }}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Form.Field>
                </div>
                <div className="w-1/2 p-2">
                  <Form.Field className="w-1/2 inline p-2">
                    <label>{t("To date")}</label>
                    <DatePicker
                      selected={
                        values[item.field] && values[item.field][1]
                          ? values[item.field][1]
                          : new Date()
                      }
                      filterDate={(date) => {
                        let fromDate = null;
                        if (values[item.field] && values[item.field][0]) {
                          fromDate = values[item.field][0];
                        }
                        if (!fromDate) return true;
                        return date > fromDate;
                      }}
                      onChange={(val: Date) => {
                        let tmp: any = [];
                        if (values[item.field]) {
                          tmp = [...values[item.field]];
                        }
                        tmp[1] = dayjs(val).startOf("day").toDate();
                        handleChange(item.field, tmp);
                      }}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Form.Field>
                </div>
              </div>
            );
          case "input":
            return (
              <div className="w-1/2 inline-block p-2">
                <Form.Field key={index} className="">
                  <label>{t(item.label)} </label>
                  <Input
                    value={values[item.field] || ""}
                    key={index}
                    defaultValue={values[item.field]}
                    name={item.field}
                    type="text"
                    onChange={(evt, { value }) => {
                      if (item.type === "number") {
                        handleChange(item.field, Number(value));
                      } else {
                        handleChange(item.field, value);
                      }
                    }}
                  />
                </Form.Field>
              </div>
            );
          case "enum":
            return (
              <div className="w-1/2 inline-block p-2">
                <Form.Field key={index}>
                  <label>{t(item.label)} </label>
                  <Enum
                    key={index}
                    multiple={item.multiple}
                    enumName={item.enum}
                    value={
                      values[item.field] === undefined ? [] : values[item.field]
                    }
                    onChange={(val: any) => {
                      handleChange(item.field, val);
                    }}
                  />
                </Form.Field>
              </div>
            );
        }
      })}
      <div className="flex mt-2 justify-end">
        <Button
          icon="close"
          onClick={() => {
            onChange({});
            // onClose();
          }}
          content={t("Reset")}
          color="red"
        />{" "}
        <Button icon="search" content={"Tìm kiếm"} primary />
      </div>
    </Form>
  );
}
